<template>
  <div class="game-layout">
    <Nuxt />

    <ClientOnly>
      <ModalComponent />
    </ClientOnly>

    <ClientOnly>
      <BigModal v-if="$route.query.hasOwnProperty('bigModal') && $route.query.bigModal">
        <RegAuthForgot />
      </BigModal>
    </ClientOnly>

    <ClientOnly>
      <BaseModalGlobal />
    </ClientOnly>

    <ClientOnly>
      <IntercomLoading />
    </ClientOnly>

    <ClientOnly>
      <AppOverlay />
    </ClientOnly>

    <ClientOnly>
      <ModalCompletionBalance />
    </ClientOnly>

    <ClientOnly>
      <NotifyToast />
    </ClientOnly>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import i18nHead from '~/util/i18n/i18nHead'
import LazyHydrate from 'vue-lazy-hydration'
const BigModal = () => import('@/components/BigModal')
const RegAuthForgot = () => import('@/components/BigModal/RegAuthForgot')
const BaseModalGlobal = () => import('@/components/Base/Modal/Global')
const IntercomLoading = () => import('@/components/IntercomLoading')
const AppOverlay = () => import('@/components/App/AppOverlay')
const ModalCompletionBalance = () => import('@/components/Cashbox/Modals/CompletionBalance')
const NotifyToast = () => import('@/components/NotifyToast')

export default {
  name: 'GameLayout',
  components: {
    LazyHydrate,
    BaseModalGlobal,
    IntercomLoading,
    BigModal,
    RegAuthForgot,
    AppOverlay,
    ModalCompletionBalance,
    NotifyToast,
  },
  head() {
    return {
      title: this.get_seoPage.title,
      ...i18nHead(this.$nuxtI18nHead({ addSeoAttributes: true })),
      bodyAttrs: { class: 'theme-dark' },
    }
  },
  computed: {
    ...mapGetters('seo', ['get_seoPage']),
    ...mapGetters('user', ['isLoggedIn']),
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$store.dispatch('user/PROFILE_INFO')
    }
  },
}
</script>
